<template>
  <div :class="[`col-lg-${span}`]">
    <div class="d-flex align-items-center form-control custom-control custom-checkbox">
      <input type="checkbox" :id="fieldKey" class="custom-control-input" v-model="internal" :disabled="disabled" />
      <label class="custom-control-label" :for="fieldKey">{{ label }}</label>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "fieldKey", "label", "span", "disabled"],
  data() {
    return {
      internal: this.value && !this.disabled ? this.value : false,
    };
  },
  watch: {
    internal: {
      immediate: true,
      handler: function (val) {
        this.$emit("input", val);
      },
    },
    disabled(val) {
      if (val) this.internal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-control {
  padding-left: 2.5rem;
}
</style>
